import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { getCurrentRole, getToken } from './Common'; 

const PrivateRoute = ({ component: Component, allowedRoles, ...rest }) => {
  const rawRole = getCurrentRole();
  const userRole = rawRole ? rawRole.toLowerCase().replaceAll(" ","_") : null;

  return (
    <Route
      {...rest}
      render={(props) => {
        if (userRole && allowedRoles.map(role => role.toLowerCase()).includes(userRole)) {
          return <Component {...props} />;
        } else {
          return <Redirect to="/dashboard" />;
        }
      }}
    />
  );
};

export default PrivateRoute;